"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _SvgIcon = _interopRequireDefault(require("@material-ui/core/SvgIcon"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function createSvgIcon(path, displayName, viewBox) {
  let Icon = function (props) {
    let output = /*#__PURE__*/_react.default.createElement(_SvgIcon.default, _extends({}, props, {
      viewBox: viewBox
    }), path);
    return output;
  };
  Icon.displayName = displayName;
  Icon.muiName = 'SvgIcon';
  return Icon;
}
var _default = exports.default = createSvgIcon;
